
export const openSONDAGGIOReport = (props) => {
  const {
    committente,
    localita,
    indirizzo,
    op,
    dittes,
    sonda,
    carotiere,
    rivestimento,
    tipologia,
    profMax,
    falda,
    qpc,
    qbf,
    qpz,
    coordinate,
    mH = [],
    mColor = [],
    mTexture = [],
    mDesc = [],
    analisiData = [],
    sptTests = [],
    pocketTests = [],
    torvaneTests = [],
    campioni = [],
    fessurazioni = [],
    nomeProva
  } = props;



  const faldaPx =
  falda === "" || falda === null || falda === undefined
    ? null
    : Number(falda) * 40;

  const getTexture = (type) => {
      const g = (value) => value.trim();

      switch (type) {

        // =========================
        // DOTS
        // =========================
        case "dots_fine":
          return g(`
            radial-gradient(circle, #000 0.8px, transparent 0.9px)
          `);

        case "dots_medium":
          return g(`
            radial-gradient(circle, #000 1.5px, transparent 1.8px)
          `);

        case "dots_coarse":
          return g(`
            radial-gradient(circle, #000 2.5px, transparent 2.8px)
          `);

        case "sand_mix":
          return g(`
            radial-gradient(circle at 2px 2px, #000 0.8px, transparent 1px),
            radial-gradient(circle at 10px 6px, #000 1.2px, transparent 1.4px),
            radial-gradient(circle at 16px 12px, #000 0.7px, transparent 1px)
          `);

        // =========================
        // HOLLOW DOTS
        // =========================
        case "dots_fine_hollow":
          return g(`
            radial-gradient(circle, transparent 0.6px, #000 1.4px, transparent 2px)
          `);

        case "dots_medium_hollow":
          return g(`
            radial-gradient(circle, transparent 0.8px, #000 2px, transparent 2.6px)
          `);

        // =========================
        // GHIAIA
        // =========================
        case "gravel_small":
          return g(`
            radial-gradient(circle at 6px 6px, #333 2px, transparent 2.2px),
            radial-gradient(circle at 18px 10px, #333 1.5px, transparent 2px),
            radial-gradient(circle at 10px 20px, #333 2px, transparent 2.2px)
          `);

        case "gravel_medium":
          return g(`
            radial-gradient(circle at 8px 6px, #333 3px, transparent 3.2px),
            radial-gradient(circle at 22px 12px, #333 2.5px, transparent 2.8px),
            radial-gradient(circle at 14px 26px, #333 2.8px, transparent 3px)
          `);

        case "gravel_large":
          return g(`
            radial-gradient(circle at 10px 8px, #333 4px, transparent 4.2px),
            radial-gradient(circle at 30px 18px, #333 3.5px, transparent 3.8px),
            radial-gradient(circle at 18px 34px, #333 4px, transparent 4.3px)
          `);

        // =========================
        // LINEE ORIZZONTALI
        // =========================
        case "lines_fine":
          return g(`
            repeating-linear-gradient(
              0deg,
              #000 0px,
              #000 1.5px,
              transparent 1.5px,
              transparent 6px
            )
          `);

        case "silt_lines_fine":
          return g(`
            repeating-linear-gradient(
              0deg,
              #000 0px,
              #000 3px,
              transparent 3px,
              transparent 10px
            )
          `);

        case "silt_lines_coarse":
          return g(`
            repeating-linear-gradient(
              0deg,
              #000 0px,
              #000 1px,
              transparent 1px,
              transparent 16px
            )
          `);

        case "organic":
          return g(`
            repeating-linear-gradient(
              0deg,
              #111 0px,
              #111 1px,
              transparent 1px,
              transparent 12px
            ),
            radial-gradient(circle, #111 1px, transparent 1.2px)
          `);

        // =========================
        // VERTICALI
        // =========================
        case "grid_vertical":
          return g(`
            repeating-linear-gradient(
              90deg,
              #000 0px,
              #000 1px,
              transparent 1px,
              transparent 8px
            )
          `);

        // =========================
        // DIAGONALI
        // =========================
        case "lines_diagonal":
          return g(`
            repeating-linear-gradient(
              45deg,
              #000 0px,
              #000 1px,
              transparent 1px,
              transparent 8px
            )
          `);

        case "fractured":
          return g(`
            repeating-linear-gradient(
              135deg,
              #000 0px,
              #000 1px,
              transparent 1px,
              transparent 10px
            )
          `);

        // =========================
        // CROSSHATCH
        // =========================
        case "crosshatch":
          return g(`
            repeating-linear-gradient(45deg, #000 0px, #000 1px, transparent 1px, transparent 8px),
            repeating-linear-gradient(-45deg, #000 0px, #000 1px, transparent 1px, transparent 8px)
          `);

        // =========================
        // GRID
        // =========================
        case "grid":
          return g(`
            repeating-linear-gradient(0deg, #000 0px, #000 1px, transparent 1px, transparent 10px),
            repeating-linear-gradient(90deg, #000 0px, #000 1px, transparent 1px, transparent 10px)
          `);

        default:
          return "none";
      }
    };

  const getTextureSize = (type) => {
          const sizes = {
            dots_fine: "16px 16px",
            dots_medium: "20px 20px",
            dots_coarse: "24px 24px",
            sand_mix: "20px 20px",
            dots_fine_hollow: "16px 16px",
            dots_medium_hollow: "20px 20px",
            gravel_small: "30px 30px",
            gravel_medium: "36px 36px",
            gravel_large: "44px 44px",
            lines_fine: "12px 12px",
            lines_diagonal: "16px 16px"
          };
          return sizes[type] || "20px 20px";
        };



  const reportWindow = window.open("", "_blank", "width=1200,height=800");
  if (!reportWindow) return;

  reportWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
    <meta charset="UTF-8">
    <title>Report Sondaggio</title>

    <style>
    /* =========================
       BASE
    ========================= */
    html, body {
      margin: 0;
      padding: 0;
      font-family: Arial, sans-serif;
      background: white;
    }
    /* =========================
       A4
    ========================= */
    .page-wrapper {
      width: 210mm;
      margin: 0 auto;
      border: 1px solid black;
    }

    /* =========================
       HEADER
    ========================= */
    .geotech-header {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      border: 1px solid black;
      padding: 6px;
    }

    /* =========================
       HEADER SECONDARIO
    ========================= */
    .geotech-subheader {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      border: 1px solid black;
      padding: 6px;
    }

    /* =========================
       COLONNE
    ========================= */
    .geotech-columns-header,
    .geotech-body {
      display: flex;
      width: 100%;
    }

    .col {
      border: 1px solid black;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
    }

    /* =========================
       HEADER COL
    ========================= */
    .geotech-columns-header .col {
      font-size: 10px;
      font-weight: bold;
      text-align: center;
      background: #f3f3f3;
    }

    /* =========================
       PROFONDITA
    ========================= */
    .depth-row {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #ddd;
    }

    .depth-row.black {
      background: #eaeaea;
    }

    /* =========================
       STRATI
    ========================= */
    .layer {
      width: 100%;
      border-bottom: 1px solid black;
    }

    /* =========================
       DESCRIZIONE
    ========================= */
    .descrizione-layer {
      position: absolute;
      left: 0;
      width: 100%;
      padding: 3px;
      font-size: 10px;
    }

    /* =========================
       PRINT
    ========================= */
    @page {
      size: A4;
      margin: 15mm;
    }

    @media print {

      body * { visibility: hidden; }

      #reportFrame,
      #reportFrame * { visibility: visible; }

      #reportFrame {
        position: absolute;
        top: 0;
        left: 0;
        width: 180mm;
      }

      * {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      .geotech-header,
      .geotech-subheader {
        break-inside: avoid;
      }
    }

    /* =========================
       LARGHEZZE COLONNE
    ========================= */
    .col:nth-child(1) { width: 3%; }
    .col:nth-child(2) { width: 6%; }
    .col:nth-child(3) { width: 20%; }
    .col:nth-child(4) { width: 23%; }
    .col:nth-child(5) { width: 8%; }
    .col:nth-child(6) { width: 8%; }
    .col:nth-child(7) { width: 8%; }
    .col:nth-child(8) { width: 8%; }
    .col:nth-child(9) { width: 8%; }
    .col:nth-child(10){ width: 8%; }


    .controls {
            position: fixed;
            top: 10px;
            right: 10px;
            z-index: 1000;
            display: flex;
            gap: 5px;
            background: rgba(255,255,255,0.9);
            padding: 5px;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }


    .print-btn {
            background: #12455b;
            color: white;
            border: none;
            width: 32px;
            height: 32px;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .print-btn:hover {
            background: #0d3445;
          }

    .geotech-sheet {
      width: 210mm;
      background: white;
      color: black;

      font-family: Arial, sans-serif;
      font-size: 10px;

      border: 1px solid black;

      display: flex;
      flex-direction: column;
    }

    .delimiterborehole {
      text-align: right;
      font-size: 12px;
      color: #666;
      padding-top: 5px;
      padding-bottom: 5px;
      padding-right: 10px; /* <-- spazio a destra */
      box-sizing: border-box;
      border: 1px solid; /* <-- questo è lo spessore */
    }

    .section-content-sond{
      flex: 1;
      min-height: 0;
      overflow-y: auto;

      display: flex;
      justify-content: center;
      align-items: flex-start;

      background: #f0f0f0;
      padding: 10px 0;

      .depth-scale {
          position: relative;
          display: flex;
          flex-direction: column;
          width: 100%;
        }

    }



    </style>
    </head>

    <body>
        <div class="section-content-sond">
            <div class="controls">
                  <button class="print-btn" onclick="window.print()" title="Salva PDF">💾</button>
                  <button class="print-btn" onclick="window.close()" title="Chiudi">✖</button>
                  <button class="print-btn" onclick="resetEditableFields()" title="Reset Campi">↺</button>
            </div>


            <div class="page-wrapper" id="reportFrame">
              <div class="delimiterborehole">
                <span>V.E.S. - Virtual Earth Suite</span>
                <span>Sviluppato dal Dott. Geol. Umberto Grechi</span>
              </div>

              <!-- ================= HEADER ================= -->
                <div class="geotech-header">

                  <!-- SINISTRA -->
                  <div>
                    <div>Ditta Esecutrice:</div>
                    <div>${dittes || "-"}</div>
                  </div>

                  <!-- CENTRO -->
                  <div>
                      <div>
                        Località:
                        <span id="localita" contenteditable="true" style="outline:none;">
                          ${localita || "-"}
                        </span>
                      </div>

                      <div>
                        Indirizzo:
                        <span id="via" contenteditable="true" style="outline:none;">
                          ${indirizzo || "-"}
                        </span>
                      </div>

                      <div>
                        Committente:
                        <span id="committente" contenteditable="true" style="outline:none;">
                          ${committente || "-"}
                        </span>
                      </div>

                      <div>
                        Data: ${new Date().toLocaleDateString("it-IT")}
                      </div>
                    </div>

                  <!-- DESTRA -->
                  <div>
                    <div>Sonda: ${sonda || "-"}</div>
                    <div>Carotiere: ${carotiere || "-"}</div>
                    <div>Rivestimento: ${rivestimento || "-"}</div>
                    <div>Operatore: ${op || "-"}</div>
                  </div>

                </div>

                <!-- ================= HEADER 2 ================= -->
                <div class="geotech-header">

                  <!-- SINISTRA -->
                  <div>
                    <div>ID Sondaggio: ${nomeProva || "-"}</div>
                    <div>Prof. max: ${profMax ? profMax + " m" : "-"}</div>
                    <div>Tipologia: ${tipologia || "-"}</div>
                  </div>

                  <!-- CENTRO -->
                  <div>
                    <div>Prof. Falda: ${falda ? falda + " m" : "-"}</div>
                    <div>Quota p.c.: ${qpc ? qpc + " m" : "0"}</div>
                    <div>B.f. Piezometro: ${qbf ? qbf + " m" : "-"}</div>
                  </div>

                  <!-- DESTRA -->
                  <div>
                    <div>WGS84 (EPSG:4326)</div>
                    <div>
                      Lat: ${coordinate ? Number(coordinate.split(",")[0]).toFixed(3) : "-"}
                    </div>
                    <div>
                      Lon: ${coordinate ? Number(coordinate.split(",")[1]).toFixed(3) : "-"}
                    </div>
                  </div>

                </div>

              <!-- COLONNE HEADER -->
              <div class="geotech-columns-header">
                <div class="col">H m</div>
                <div class="col">Sp</div>
                <div class="col">Stratigrafia</div>
                <div class="col">Descrizione</div>
                <div class="col">Falda</div>
                <div class="col">Pz</div>
                <div class="col">Pt</div>
                <div class="col">Tv</div>
                <div class="col">SPT</div>
                <div class="col">C</div>
              </div>

              <!-- BODY -->
              <div class="geotech-body">

                 <!-- PROFONDITÀ -->
                  <div class="col profondita" style="position:relative; height:${profMax * 40}px;">
                    ${Array.from({ length: profMax }).map((_, i) => `
                      <div style="height:40px; display:flex; align-items:center; justify-content:center; border-bottom:1px solid #ddd; ${i % 2 === 0 ? "background:#fff" : "background:#eaeaea"}">
                        ${i === 0 ? "" : i}
                      </div>
                    `).join("")}
                  </div>

                  <!-- SPESSORE (vuota) -->
                  <div class="col spessore" style="position:relative; height:${props.profMax * 40}px;">
                      ${(() => {

                        let html = '';
                        let top = 0;

                        for (let i = 0; i < props.mH.length; i++) {

                          const spessore = Number(props.mH[i]);
                          const h = spessore * 40;

                          if (h <= 0) continue;

                          html += `
                            <div style="
                              position:absolute;
                              top:${top}px;
                              height:${h}px;
                              width:100%;
                              display:flex;
                              align-items:center;
                              justify-content:center;
                              font-size:11px;
                              font-weight:bold;
                              font-family:Roboto;
                              box-sizing:border-box;
                              border-bottom:1px solid #000;
                            ">
                              ${spessore}
                            </div>
                          `;

                          top += h;
                        }

                        return html;

                      })()}
                    </div>

                  <div class="col stratigrafia" style="position:relative; height:${props.profMax * 40}px;">
                      ${(() => {

                        let layersHTML = '';

                        for (let i = 0; i < props.mH.length; i++) {

                          const spessore = Number(props.mH[i]);
                          const h = spessore * 40;

                          if (h <= 0) continue;

                          const color = props.mColor?.[i] || "#fff";
                          const texture = props.mTexture?.[i] || "none";

                          const backgroundImage = getTexture(texture);

                          const isGradient = typeof backgroundImage === "string" && !backgroundImage.includes("url");

                          layersHTML += `
                            <div style="
                              height:${h}px;
                              background-color:${color};
                              background-image:${backgroundImage};
                              background-repeat:repeat;
                              background-size:${isGradient ? getTextureSize(texture) : "auto"};
                              background-position: 0 0;
                            "></div>
                          `;
                        }

                        return layersHTML;

                      })()}
                    </div>


                <div
                  class="col descrizione"
                  style="position:relative; height:${profMax * 40}px;"
                >
                  ${(() => {
                    let top = 0;

                    return mH
                      .map((spessore, i) => {
                        const h = Number(spessore) * 40;

                        if (h <= 0) return "";

                        const el = `
                          <div style="
                            position:absolute;
                            top:${top}px;
                            height:${h}px;
                            display:flex;
                            align-items:center;
                            padding:4px;
                            font-size:11px;
                            font-family:Roboto;
                            font-weight:bold;
                            width:100%;
                          ">
                            ${mDesc?.[i] || ""}
                          </div>
                        `;

                        top += h;
                        return el;
                      })
                      .join("");
                  })()}
                </div>

                <div class="col falda" style="position: relative; height: ${profMax * 40}px;">
                  ${falda ? `
                    <div style="
                      position: absolute;
                      top: ${faldaPx}px;
                      left: 0;
                      width: 100%;
                      height: 2px;
                      background-color: #4f92e8;
                      z-index: 2;
                    "></div>

                    <div style="
                      position: absolute;
                      top: ${faldaPx + 5}px;
                      left: 10%;
                      width: 80%;
                      height: 2px;
                      background-color: #4f92e8;
                      opacity: 0.6;
                      z-index: 2;
                    "></div>

                    <div style="
                      position: absolute;
                      top: ${faldaPx - 15}px;
                      left: 50%;
                      transform: translateX(-50%);
                      z-index: 3;
                    ">
                      <div style="
                        width: 0;
                        height: 0;
                        border-left: 10px solid transparent;
                        border-right: 10px solid transparent;
                        border-top: 16px solid black;
                      "></div>

                      <div style="
                        position: absolute;
                        top: 2px;
                        left: 2px;
                        width: 0;
                        height: 0;
                        border-left: 8px solid transparent;
                        border-right: 8px solid transparent;
                        border-top: 14px solid #4f92e8;
                      "></div>
                    </div>
                  ` : ""}
                </div>

                <div class="col pz" style="position: relative; height: ${profMax * 40}px;">
                  ${qpz ? `

                    <!-- LINEA 1 -->
                    <div style="
                      position: absolute;
                      left: 30%;
                      top: ${qpz * 40}px;
                      width: 2px;
                      height: ${(profMax - qpz) * 40}px;
                      background-color: #0f172a;
                      opacity: 0.6;
                      z-index: 2;
                    "></div>

                    <!-- LINEA 2 -->
                    <div style="
                      position: absolute;
                      left: 70%;
                      top: ${qpz * 40}px;
                      width: 2px;
                      height: ${(profMax - qpz) * 40}px;
                      background-color: #0f172a;
                      opacity: 0.6;
                      z-index: 2;
                    "></div>

                  ` : ""}

                  ${fessurazioni.map((f) => {
                    if (!f.inizio || !f.fine) return "";

                    const top = Number(f.inizio) * 40;
                    const height = (Number(f.fine) - Number(f.inizio)) * 40;

                    return `
                      <!-- FASCIA -->
                      <div style="
                        position: absolute;
                        top: ${top}px;
                        left: 0;
                        width: 100%;
                        height: ${height}px;
                        background-color: #4f92e8;
                        opacity: 0.2;
                        z-index: 1;
                      "></div>

                      <!-- RETINO ORIZZONTALE -->
                      ${Array.from({ length: Math.floor(height / 10) }).map((_, idx) => `
                        <div style="
                          position: absolute;
                          left: 30%;
                          top: ${top + idx * 10}px;
                          width: 40%;
                          height: 1px;
                          background-color: #4f92e8;
                          opacity: 0.5;
                          z-index: 1;
                        "></div>
                      `).join("")}
                    `;
                  }).join("")}
                </div>

                <div class="col pkt" style="position: relative; height: ${profMax * 40}px;">
                  ${pocketTests.map((p) => {
                    if (!p.profondita || !p.valore) return "";

                    const top = Number(p.profondita) * 40;

                    return `
                      <div style="
                        position: absolute;
                        left: 10%;
                        top: ${top}px;
                        width: 25%;
                        height: 2px;
                        background-color: #000;
                        z-index: 2;
                      "></div>

                      <div style="
                        position: absolute;
                        left: 50%;
                        top: ${top}px;
                        transform: translateY(-50%);
                        font-size: 11px;
                        color: #000;
                        font-weight: 500;
                        white-space: nowrap;
                      ">
                        ${p.valore}
                      </div>
                    `;
                  }).join("")}
                </div>


                <div class="col torvane" style="position: relative; height: ${profMax * 40}px;">
                  ${torvaneTests.map((t) => {
                    if (!t.profondita || !t.valore) return "";

                    const top = Number(t.profondita) * 40;

                    return `
                      <div style="
                        position: absolute;
                        left: 10%;
                        top: ${top}px;
                        width: 25%;
                        height: 2px;
                        background-color: #000;
                        z-index: 2;
                      "></div>

                      <div style="
                        position: absolute;
                        left: 50%;
                        top: ${top}px;
                        transform: translateY(-50%);
                        font-size: 11px;
                        color: #000;
                        font-weight: 500;
                        white-space: nowrap;
                      ">
                        ${t.valore}
                      </div>
                    `;
                  }).join("")}
                </div>


                <div class="col spt" style="position: relative; height: ${profMax * 40}px;">
                  ${sptTests.map((s) => {
                    if (!s.profondita || !s.valore) return "";

                    const top = Number(s.profondita) * 40;

                    return `
                      <div style="
                        position: absolute;
                        left: 10%;
                        top: ${top}px;
                        width: 25%;
                        height: 2px;
                        background-color: #000;
                        z-index: 2;
                      "></div>

                      <div style="
                        position: absolute;
                        left: 50%;
                        top: ${top}px;
                        transform: translateY(-50%);
                        font-size: 11px;
                        color: #000;
                        font-weight: 500;
                        white-space: nowrap;
                      ">
                        ${s.valore}
                      </div>
                    `;
                  }).join("")}
                </div>

                <div class="col campioni" style="position: relative; height: ${profMax * 40}px;">
                  ${campioni.map((c) => {
                    if (!c.profondita || !c.tipologia || !c.qualita) return "";

                    const top = Number(c.profondita) * 40;

                    let campSigla = "";
                    switch (c.campionatore) {
                      case "Shelby":
                        campSigla = "S";
                        break;
                      case "Denison":
                        campSigla = "D";
                        break;
                      case "Mazier":
                        campSigla = "M";
                        break;
                      default:
                        campSigla = "";
                    }

                    return `
                      <!-- LINEA -->
                      <div style="
                        position: absolute;
                        left: 2%;
                        top: ${top}px;
                        width: 7%;
                        height: 2px;
                        background-color: #000;
                      "></div>

                      <!-- CAMPIONATORE -->
                      ${campSigla ? `
                        <div style="
                          position: absolute;
                          left: 15%;
                          top: ${top - 10}px;
                          transform: translateY(-50%);
                          font-size: 9px;
                          font-weight: 700;
                          color: #111;
                          white-space: nowrap;
                        ">
                          ${campSigla}
                        </div>
                      ` : ""}

                      <!-- TIPOLOGIA - QUALITÀ -->
                      <div style="
                        position: absolute;
                        left: 15%;
                        top: ${top + 6}px;
                        transform: translateY(-50%);
                        font-size: 10px;
                        font-weight: 500;
                        white-space: nowrap;
                      ">
                        ${c.tipologia} - ${c.qualita}
                      </div>
                    `;
                  }).join("")}
                </div>

              </div>

              <!-- ================= LEGGENDA ================= -->
                <div
                  style="
                    margin-top: 20px;
                    padding: 10px;
                    font-size: 12px;
                    font-family: Arial, sans-serif;
                  "
                >
                  <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                    Legenda Campioni
                  </div>

                  <div style="display:flex; gap:20px; flex-wrap:wrap; margin-bottom:8px;">
                    <div><b>CD/R</b> = Campione disturbato o rimaneggiato</div>
                    <div><b>CDL</b> = Campione a disturbo limitato</div>
                    <div><b>CI</b> = Campione indisturbato</div>
                  </div>

                  <div style="display:flex; gap:15px; flex-wrap:wrap; margin-bottom:8px;">
                    <div><b>Q1</b> = qualità molto bassa</div>
                    <div><b>Q2</b> = qualità bassa</div>
                    <div><b>Q3</b> = qualità media</div>
                    <div><b>Q4</b> = qualità alta</div>
                    <div><b>Q5</b> = qualità molto alta</div>
                  </div>

                  <div style="display:flex; gap:20px; flex-wrap:wrap;">
                    <div><b>S</b> = Shelby</div>
                    <div><b>D</b> = Denison</div>
                    <div><b>M</b> = Mazier</div>
                  </div>
        </div>
       </div>

    <!-- ================= SCRIPT FUNZIONI ================= -->
    <script>
      function saveData() {
        const data = {
          committente: document.getElementById('committente')?.value || '',
          localita: document.getElementById('localita')?.value || '',
          via: document.getElementById('via')?.value || '',
          nome: document.getElementById('nome')?.value || ''
        };
        localStorage.setItem('cptReportData', JSON.stringify(data));
      }

      function loadSavedData() {
        const saved = localStorage.getItem('cptReportData');
        if (!saved) return;

        const data = JSON.parse(saved);

        if (document.getElementById('committente'))
          document.getElementById('committente').value = data.committente || '';

        if (document.getElementById('localita'))
          document.getElementById('localita').value = data.localita || '';

        if (document.getElementById('via'))
          document.getElementById('via').value = data.via || '';

        if (document.getElementById('nome'))
          document.getElementById('nome').value = data.nome || '';
      }

      function resetEditableFields() {
        const ids = ['committente', 'localita', 'via', 'nome'];

        ids.forEach(id => {
          const el = document.getElementById(id);
          if (!el) return;

          el.innerText = '-';   // oppure ''
        });

        localStorage.removeItem('cptReportData');
      }

      // AUTO LOAD
      window.onload = function () {
        loadSavedData();
      };

      // AUTO SAVE (solo se esistono i campi)
      document.addEventListener('input', function(e) {
        if (['committente','localita','via','nome'].includes(e.target.id)) {
          saveData();
        }
      });

    </script>

    </body>
    </html>
    `);

      reportWindow.document.close();


    };
